//TODO: Make these ids or they will break when changed

export const STATUS_TYPES = {
  DONE: "done",
  PENDING: "pending",
};
